var strength = {
	0: "Sehr schlecht",
	1: "Schlecht",
	2: "Schwach",
	3: "Gut",
	4: "Stark"
}

var password = document.getElementById(cfrequest.passwordFieldId);
var meter = document.getElementById(cfrequest.passwordFieldId + '-strength-meter');
var text = document.getElementById(cfrequest.passwordFieldId + '-strength-text');

password.addEventListener('input', function()
{
	var val = password.value;
	var result = zxcvbn(val);

	// Update the password strength meter
	meter.value = result.score+1;
 
	// Update the text indicator
	if(val !== "") {
			text.innerHTML = "Passwortst&auml;rke: " + "<strong>" + strength[result.score] + "</strong>"; 
	}
	else {
			text.innerHTML = "";
	}
});